import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/withdrawal`;

class WithdrawalMangementServices {
  async getWithdrawalList(page, limit, filter, status, fromDate, toDate) {
    try {
      const params = new URLSearchParams({ page: String(page), limit: String(limit) });
      if (filter) params.set("filter", filter);
      if (status) params.set("status", status);
      if (fromDate) params.set("from_date", fromDate);
      if (toDate) params.set("to_date", toDate);
      const response = await requestToken.get(
        `${API_ROUTE}/get-withdrawal-list?${params.toString()}`
      );
      return response;
    } catch (error) {
      console.error("Error in getWithdrawalList:", error);
      throw error;
    }
  }

  async requestWithdraw(amount, remark) {
    try {
      const payload = { amount, remark };
      const response = await requestToken.post(
        `${API_ROUTE}/request-withdraw`,
        payload
      );
      return response;
    } catch (error) {
      console.error("Error in requestWithdraw:", error);
      throw error;
    }
  }

  async updateStatus(id, action, adminRemark) {
    try {
      const payload = { id, action, admin_remark: adminRemark };
      const response = await requestToken.post(
        `${API_ROUTE}/update-status`,
        payload
      );
      return response;
    } catch (error) {
      console.error("Error in updateStatus:", error);
      throw error;
    }
  }

  /**
   * Every row matching the current filters, for export. Pages through the
   * normal list endpoint rather than asking the server for an unbounded
   * result, matching how transaction history exports already work.
   */
  async getWithdrawalListForExport({ status, filter, fromDate, toDate }) {
    const pageSize = 100;
    let page = 1;
    let totalPages = 1;
    const all = [];

    do {
      const res = await this.getWithdrawalList(
        page,
        pageSize,
        filter,
        status,
        fromDate,
        toDate,
      );
      if (!res?.isSuccess) break;
      all.push(...(res.data || []));
      totalPages = res.pagination?.totalPages || 1;
      page += 1;
      // Hard stop so a runaway dataset cannot hang the browser.
      if (page > 100) break;
    } while (page <= totalPages);

    return all;
  }

  /** Withdrawable balance + live fee terms for the caller. */
  async getWithdrawalConfig() {
    try {
      const response = await requestToken.get(`${API_ROUTE}/config`);
      return response;
    } catch (error) {
      console.error("Error in getWithdrawalConfig:", error);
      throw error;
    }
  }

  /** A player's saved payout accounts, for approvers reviewing a request. */
  async getBankAccountsByUser(userId) {
    try {
      const response = await requestToken.get(
        `${process.env.REACT_APP_NODE_URL}/api/bank-account/by-user/${userId}`
      );
      return response;
    } catch (error) {
      console.error("Error in getBankAccountsByUser:", error);
      throw error;
    }
  }
}

export default WithdrawalMangementServices